// The languages the site is published in, from content/i18n/locales.json,
// which backend/i18n.py reads too. The first one is the default: its pages
// have no URL prefix (/about); every other language gets /<code> (/pl/about).
// Adding a language: see README.md in this folder.
import registry from '../../public/content/i18n/locales.json';

export const LOCALES = registry.locales.map(locale => locale.code);
export const DEFAULT_LOCALE = LOCALES[0];

export function localeInfo(code) {
  return registry.locales.find(locale => locale.code === code) || registry.locales[0];
}

// '' for the default language, '/pl' for the others
export function localePrefix(code) {
  return code === DEFAULT_LOCALE ? '' : `/${code}`;
}

// localePath('/about', 'pl') -> '/pl/about', localePath('/', 'pl') -> '/pl'
export function localePath(path, code) {
  const prefix = localePrefix(code);
  if (!prefix) return path || '/';
  return !path || path === '/' ? prefix : `${prefix}${path}`;
}

// '/pl/about' -> { locale: 'pl', path: '/about' }, '/pl' -> { locale: 'pl', path: '/' }.
// Paths without a known prefix belong to the default language.
export function splitLocalePath(path) {
  const match = /^\/([a-z]{2})(?=\/|$)/.exec(path);
  if (match && match[1] !== DEFAULT_LOCALE && LOCALES.indexOf(match[1]) !== -1) {
    return { locale: match[1], path: path.slice(3) || '/' };
  }
  return { locale: DEFAULT_LOCALE, path };
}

// The language menu's entries: this page in every language it exists in
// (all of them when `languages` isn't given), the current one marked.
export function languageMenuItems(path, current, languages = LOCALES) {
  return LOCALES.filter(code => languages.indexOf(code) !== -1).map(code => ({
    code,
    name: localeInfo(code).name,
    hreflang: localeInfo(code).hreflang,
    path: localePath(path, code),
    current: code === current
  }));
}

// '2026-09-27' -> '27 September 2026' / '27 września 2026'. Same text as
// format_date() in backend/i18n.py.
export function formatDate(iso, code) {
  const info = localeInfo(code);
  const [year, month, day] = iso.split('-').map(Number);
  return info.dateFormat
    .replace('{day}', day)
    .replace('{month}', info.months[month - 1])
    .replace('{year}', year);
}
